class ComparativeEmptyDay {

    constructor(date) {
        this.date = date;
    }

}

export default ComparativeEmptyDay;
